import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/storage/modules/storage.js'
import enterprise from '@/storage/modules/enterprise_module.js'
import app from "./modules/app_module";
import auth from "./modules/auth_module";
Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		app,
		auth,
		storage,
		enterprise
	}
})



// WEBPACK FOOTER //
// ./src/storage/index.js